import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CookieHelper } from '../../../shared/cookie-helper';
import { AppConfig } from '../../models/contact-modal/appConfig.model';
import { AppconfigService } from '../contact-services/shared/appconfig.service';

@Injectable({ providedIn: 'root' })
export class SessionService {
    private encryptedUser: string = '';
    private myHomeUrl: string = '';
    private pollInterval: any;

    constructor(
        private ngZone: NgZone,
        private _appConfigService: AppconfigService,
        private router: Router
    ) {
        this.getAppHomeConfig();
        this.listenStorageEvents();  // 🔑 instant multi-tab sync (same domain)

    }

    private async getAppHomeConfig() {
        try {
            const result: AppConfig = await this._appConfigService.getDefaultHome(this.encryptedUser);
            if (result) {
                this.myHomeUrl = result.homeURL;
            }
        } catch (err) {
            console.error('Error loading home config', err);
        }
    }

    async startSession(token: string) {
        // store login state in both cookie + localStorage
        localStorage.setItem("token", token);
        CookieHelper.setCookie('isLoggedIn', 'true', 8); // cookie shared across subdomains
    }
    async getSession(): Promise<string> {
        return CookieHelper.getCookie('token_univ')?.toString() || '';
    }
    logout() {
        // clear both storage + cookie
        localStorage.removeItem("token");
        CookieHelper.eraseCookie('isLoggedIn');
        CookieHelper.eraseCookie('token_univ');
        // notify other tabs instantly
        localStorage.setItem("logout-event", Date.now().toString());

        // redirect current tab
        //this.router.navigate(['/login']);
    }

    markLoggedIn() {
        CookieHelper.setCookie('isLoggedIn', 'true');
    }

    private listenStorageEvents() {
        // fires in all other tabs of same browser+domain
        window.addEventListener('storage', (event) => {
            if (event.key === 'logout-event') {
                this.ngZone.run(() => window.location.href = this.myHomeUrl);
            }
        });
    }

    startPolling() {
        this.ngZone.runOutsideAngular(() => {
            this.pollInterval = setInterval(() => {
                if (!this.isLoggedIn()) {
                    if (this.router.url.indexOf('cm-contract-client') == -1) {
                        console.log('this.router.routerState.snapshot.url', this.router.url);
                        clearInterval(this.pollInterval);
                        this.ngZone.run(() => window.location.href = this.myHomeUrl);
                    }
                }
            }, 1000); // every 1 second
        });
    }

    isLoggedIn(): boolean {
        return CookieHelper.getCookie('isLoggedIn') === 'true';
    }

    clearPooling() {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
    }
}
